import {TrialUtils} from '../shared/utils/trial/trial-utils';
import {OmapiIdConstants} from '../shared/omapi-id-constants';

export class Trial {
  voucherid: string;
  omapiId: string;
  label: string;
  duration: number;
  salesOfferingSpecificationId: string;

  get logoUrl() {
    return TrialUtils.getLogoUrlForTrialOmapiId(this.omapiId);
  }

  get parentOmapiId(): string {
    return this.omapiId ? OmapiIdConstants.PRODUCT_TRIAL_MAP.get(this.omapiId) : '';
  }
}
